var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row voffset2"},[_c('div',{staticClass:"well well-lg",domProps:{"innerHTML":_vm._s(_vm.explanation)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }